interface WishlistButton {
  productIsInWishlist: boolean;
  product: any;
  handleWishlistClick(handle: string, variantId: string): void;
  isProductInWishlist(handle: string): void;
}

export default {
  name: "wishlistButton",
  component(): WishlistButton {
    return {
      productIsInWishlist: false,
      product: null,

      handleWishlistClick(handle: string, variantId: string) {
        if (this.productIsInWishlist) {
          window.Maestrooo.wishlist.removeProduct(handle, variantId);
          this.productIsInWishlist = false;
        } else {
          window.Maestrooo.wishlist.addProduct(handle, variantId);
          this.productIsInWishlist = true;
        }
      },

      isProductInWishlist(handle: string) {
        document.addEventListener("DOMContentLoaded", async () => {
          await window.Maestrooo.wishlist
            .containsProduct(handle)
            .then((productIsInWishlist) => {
              console.log(productIsInWishlist);
              this.productIsInWishlist = productIsInWishlist;
            })
            .catch((error) => {
              console.error(error);
            });
        });
      },
    };
  },
};
